import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {TemporaryVariable} from 'projects/app-misc/src/app/modules/admin-panel/data/temporary-variable';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AdminPanelService} from 'projects/app-misc/src/app/modules/admin-panel/data/admin-panel.service';
import {MiscSnackBarService} from 'projects/core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {NotificationCondition} from 'projects/app-misc/src/app/modules/admin-panel/data/nfs-condition';
import {NfsSubscription} from 'projects/app-misc/src/app/modules/admin-panel/data/nfs-sub';
import {forkJoin} from 'rxjs';
import {
  NfsSubEditorComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/system-nfs-changer/nfs-sub-editor/nfs-sub-editor.component';

@Component({
  selector: 'app-system-nfs-editor-dialog',
  templateUrl: './system-nfs-editor-dialog.component.html',
  styleUrls: ['./system-nfs-editor-dialog.component.scss']
})
export class SystemNfsEditorDialogComponent implements OnInit {
  saveLoading = false;

  variablesLoading = false;

  tempCondition: NotificationCondition

  tempVariables: TemporaryVariable[];

  @ViewChild('emailChangerArea', {static: true})
  addPunchItemTextArea: ElementRef;

  nfsSubs: NfsSubscription[]

  constructor(
    protected dialogRef: MatDialogRef<SystemNfsEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: {
      condition: NotificationCondition
    }
  ) {
  }

  ngOnInit(): void {
    this.tempCondition = Object.assign({}, this.data.condition)

    this.variablesLoading = true;

    forkJoin([this.adminPanelService.getConditionTemplates(this.tempCondition.clazz), this.adminPanelService.getConditionSubs(this.tempCondition.id)]).subscribe(response => {
      const vars = response[0]
      const subs = response[1]
      this.tempVariables = vars;
      this.variablesLoading = false;

      this.nfsSubs = subs

    }, error => {
      this.variablesLoading = false;
    })
  }

  saveCond() {
    this.saveLoading = true;

    this.adminPanelService.saveClientsCondition(this.tempCondition).subscribe(newCond => {
      this.miscSnackBarService.openSuccessSnackBar('Success!')

      this.dialogRef.close(newCond);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.saveLoading = false;
    })
  }

  variableClick(variable: string) {
    if (!this.saveLoading) {
      const textAreaElement = this.addPunchItemTextArea.nativeElement as HTMLTextAreaElement
      const cursorPosition = textAreaElement.selectionEnd;
      this.utilsFunc(textAreaElement, variable, cursorPosition)
    }
  }

  utilsFunc(textAreaElement: HTMLTextAreaElement, textToInsert: string, cursorPosition: number) {
    textAreaElement.value = this.addStr(textAreaElement.value, cursorPosition, textToInsert + ' ');
    textAreaElement.setSelectionRange(cursorPosition + textToInsert.length + 1, cursorPosition + textToInsert.length + 1);
    textAreaElement.focus()
  }

  addStr(str: string, index: number, stringToAdd: string) {
    return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

  addNewSub() {
    const dialogRef = this.matDialog.open(NfsSubEditorComponent, {
      data: {
        condId: this.tempCondition.id,
        nfsSub: new NfsSubscription()
      },
      panelClass: 'nfs-sub-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res && res instanceof NfsSubscription) {
        this.nfsSubs.push(res)
      }
    })
  }

  editSub(nfsSub: NfsSubscription) {
    const dialogRef = this.matDialog.open(NfsSubEditorComponent, {
      data: {
        condId: this.tempCondition.id,
        nfsSub
      },
      panelClass: 'nfs-sub-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res && res instanceof NfsSubscription) {
        const fIndex = this.nfsSubs.findIndex(sub => sub.id === res.id)
        if (fIndex > -1) {
          this.nfsSubs[fIndex] = res
        }
      } else if (res === 'delete') {
        const index = this.nfsSubs.indexOf(nfsSub, 0)

        if (index > -1) {
          this.nfsSubs.splice(index, 1);
        }
      }
    })
  }


}
